export default __webpack_public_path__ + "static/media/1.eb448156.gif";